import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserIdentifierUpdateService {
  private identifierUpdateSubject = new BehaviorSubject<{organizationKeyOne: number, organizationKeyTwo: number} | null>(null);
  
  public identifierUpdate$ = this.identifierUpdateSubject.asObservable();

  updateIdentifiers(organizationKeyOne: number, organizationKeyTwo: number) {
    this.identifierUpdateSubject.next({ organizationKeyOne, organizationKeyTwo });
  }
}
